export interface ErrorResponse {
  [key: string]: string | undefined;
}

export const passwordValidator = (password: string): ErrorResponse => {
  const errors: ErrorResponse = {};
  if (password.length < 8) {
    errors.length = 'Use 8 or more characters';
  }
  if (!/[A-Z]/.test(password)) {
    errors.uppercase = 'Use upper case letters';
  }
  if (!/[a-z]/.test(password)) {
    errors.lowercase = 'Use lower case letters';
  }
  if (!/[0-9]/.test(password)) {
    errors.number = 'Use a number';
  }
  if (!/[!@#$%^&*]/.test(password)) {
    errors.special = 'Use a symbol';
  }
  return errors;
};
export const getPasswordErrorMessages = (errors: ErrorResponse) => {
  return ['length', 'uppercase', 'lowercase', 'number', 'special']
    .map((key) => errors[key])
    .filter(Boolean) // Drop the rules that passed
    .join('\n'); // One rule per line
};
